/**
 * @generated SignedSource<<bf73609bb3d9e2426fae54a36045e865>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productDuplicationTaskQueriesCancelMutation$variables = {
  taskId: number;
};
export type productDuplicationTaskQueriesCancelMutation$data = {
  readonly cancelProductTask: boolean;
};
export type productDuplicationTaskQueriesCancelMutation = {
  response: productDuplicationTaskQueriesCancelMutation$data;
  variables: productDuplicationTaskQueriesCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskId",
        "variableName": "taskId"
      }
    ],
    "kind": "ScalarField",
    "name": "cancelProductTask",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productDuplicationTaskQueriesCancelMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productDuplicationTaskQueriesCancelMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "8d601f3568dc23083d468923cf6455fd",
    "id": null,
    "metadata": {},
    "name": "productDuplicationTaskQueriesCancelMutation",
    "operationKind": "mutation",
    "text": "mutation productDuplicationTaskQueriesCancelMutation(\n  $taskId: Long!\n) {\n  cancelProductTask(taskId: $taskId)\n}\n"
  }
};
})();

(node as any).hash = "20697ec977c4ec3aa116376d5332efd4";

export default node;
